import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { iFullStoreState } from '../../shared/interfaces';
import { toggleMapLegendShow } from '../../stores/reducers/mapLegendUI-actions';
import styles from './LegendToggleButton.module.scss';

const LegendToggleButton: React.FC = () => {
  const dispatch = useDispatch();
  const isMapLegendVisible = useSelector<iFullStoreState, boolean>(
    (state) => state.mapLegendUI.isMapLegendVisible
  );
  const isGeoFenceContainerVisible = useSelector<iFullStoreState, boolean>(
    (state) => state.fencesContainerUI.isGeoFenceContainerVisible
  );

  const handleToggle = () => {
    dispatch(toggleMapLegendShow());
  };

  // Don't show button when geofence is visible
  if (isGeoFenceContainerVisible) {
    return null;
  }

  return (
    <button
      className={styles.toggleButton}
      onClick={handleToggle}
      title={isMapLegendVisible ? 'Hide Tags Legend' : 'Show Tags Legend'}
      aria-label={isMapLegendVisible ? 'Hide Tags Legend' : 'Show Tags Legend'}
    >
      {isMapLegendVisible ? 'Hide' : 'Show'}
    </button>
  );
};

export default LegendToggleButton;